import { IRootState } from 'reducers';

export const widgetsSelector = (state: IRootState) => state.widgets;
export const widgetsDataSelector = (state: IRootState) => widgetsSelector(state).content.data;
export const widgetsDataLoadingSelector = (state: IRootState) => widgetsSelector(state).loading;
